import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import KinerjaBerandaIndex from 'app/KinerjaBerandaPage/pages/Index'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'
import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { KinerjaBerandaIndexProps } from 'app/KinerjaBerandaPage/pages/Index'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    _toggle: TToggleKeyValuePair
  ): Promise<{ props: KinerjaBerandaIndexProps }> => {
    const currentTime = new Date().getTime()
    const showBanner = currentTime < new Date('2024-04-10 00:00:00').getTime() // Banner will be shown until before 10 April 2024 00:00:00 GMT+7

    return {
      props: {
        showBanner,
        prevRoute: context?.req?.headers?.referer || '',
      },
    }
  },
})

const Page = (props: PageProps & KinerjaBerandaIndexProps) => (
  <KinerjaTipeProvider tipe="SPF">
    <KinerjaBerandaIndex {...props} />
  </KinerjaTipeProvider>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
}

export default Page
